import { type FC } from 'react';

export const WhySgSmartRoutingImpactTrendIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M2.5 13.3333 6.90476 8.92857 10.7143 12.7381 17.5 5.95238"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 5H17.5V10"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgSmartRoutingValueMoneyIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M10 1.66675V18.3334"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1667 4.16675H7.91667C6.30691 4.16675 5 5.47366 5 7.08341C5 8.69317 6.30691 10.0001 7.91667 10.0001H12.0833C13.6931 10.0001 15 11.307 15 12.9167C15 14.5265 13.6931 15.8334 12.0833 15.8334H5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
